import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ content, attrs = {}, animate, isPuffContent = false, puffSubHeader = false }) => {
	const style = {};
	const HeadingTag = `h${content?.level || '2'}`;
	const HeadingContent = animate ? `<span>${content.rawText.replace('\'', '’').replace(/<br\s?\/?>/g, '\n').split('').join('</span><span>')}</span>` : content.rawText.replace('\'', '’');
	let headingClasses = [s.heading];
	if (puffSubHeader) headingClasses.push(s.heading__puffSubHeader);
	if (isPuffContent) headingClasses.push(s.heading__puffContent);
	if (attrs.className) headingClasses = [...headingClasses, attrs.className.map((cN) => s[`heading${cN}`])];
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textTransform) style.textTransform = attrs.textTransform;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;
	if (attrs.fontFamily) headingClasses = [...headingClasses, s[`heading__${attrs.fontFamily}`]];

	return (
		<div id={urlify(content.rawText)} className={headingClasses.join(' ')} style={style}>
			<HeadingTag className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize}` : null)].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(HeadingContent) }} />
		</div>
	);
};

export default hot(module)(Heading);
